import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import {
  Description as DetailsIcon,
  AttachMoney as BudgetIcon,
  Assignment as TasksIcon,
  Inventory as ResourcesIcon,
  Poll as FeedbackIcon,
  Gavel as ComplianceIcon,
  Group as TeamIcon,
  InsertChart as AnalyticsIcon
} from '@mui/icons-material';
import { Event } from '@/types/events';
import { EventDetails } from './tabs/EventDetails';
import { BudgetManagement } from './tabs/BudgetManagement';
import { TaskManagement } from './tabs/TaskManagement';
import { ResourceManagement } from './tabs/ResourceManagement';
import { FeedbackSystem } from './tabs/FeedbackSystem';
import { ComplianceTracking } from './tabs/ComplianceTracking';
import { TeamCollaboration } from './tabs/TeamCollaboration';
import { EventAnalytics } from './tabs/EventAnalytics';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    id={`event-tabpanel-${index}`}
    aria-labelledby={`event-tab-${index}`}
    sx={{ flex: 1, overflow: 'auto' }}
  >
    {value === index && children}
  </Box>
);

interface EventTabsProps {
  event: Event;
  onUpdate: (updatedEvent: Event) => void;
}

export const EventTabs: React.FC<EventTabsProps> = ({ event, onUpdate }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabs = [
    { icon: <DetailsIcon />, label: 'Details', component: EventDetails },
    { icon: <BudgetIcon />, label: 'Budget', component: BudgetManagement },
    { icon: <TasksIcon />, label: 'Tasks', component: TaskManagement },
    { icon: <ResourcesIcon />, label: 'Resources', component: ResourceManagement },
    { icon: <FeedbackIcon />, label: 'Feedback', component: FeedbackSystem },
    { icon: <ComplianceIcon />, label: 'Compliance', component: ComplianceTracking },
    { icon: <TeamIcon />, label: 'Team', component: TeamCollaboration },
    { icon: <AnalyticsIcon />, label: 'Analytics', component: EventAnalytics }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            icon={tab.icon}
            label={tab.label}
            id={`event-tab-${index}`}
            aria-controls={`event-tabpanel-${index}`}
            iconPosition="start"
          />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <TabPanel key={index} value={value} index={index}>
          {React.createElement(tab.component, { event, onUpdate })}
        </TabPanel>
      ))}
    </Box>
  );
};